export enum TemplateType {
  jsonTemplate = 5,
}
